module.exports = "query ($filter: ResidentialFilter) {\n  Residentials(filter: $filter) {\n    id\n    name\n  }\n}\n"